const edit_image_AI_page = {
  edit_image: "Éditer l'image",
  regenerated_image: "Re-générer l'image",
}

export default edit_image_AI_page
